import { render, staticRenderFns } from "./BarcodeComponent.vue?vue&type=template&id=3cd28aa7&"
import script from "./BarcodeComponent.vue?vue&type=script&lang=js&"
export * from "./BarcodeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports